import { ShieldCheck, Cpu, Users } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

export function ValuesSection({ pillarsHeader, pillars }) {
  const { translate } = useLanguage();
console.log(pillars);

  const icons = [ShieldCheck, Cpu, Users];
  // Example royalty-free images
  const bgImages =pillars.filter(pillar => pillar?.bg_image?.value).map(pillar => pillar?.bg_image?.value || "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80");

  if (!Array.isArray(pillars) || pillars.length === 0) {
    console.warn("ValuesSection: 'pillars' prop is not a valid non-empty array.");
    return null;
  }

  return (
    <section className="bg-bg-blue py-20 sm:py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16 sm:mb-20">
          <p className="text-[#3b82f6] text-[10px] sm:text-xs font-black tracking-[0.2em] uppercase mb-4">
            {pillarsHeader?.small_heading?.value || 'CORE PILLARS'}
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-[42px] font-black text-white tracking-tight">
            {pillarsHeader?.main_title?.value || translate('newAbout.values.title')}
          </h2>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {pillars.map((pillar, idx) => {
            const Icon = icons[idx % icons.length];
            const bgImage = bgImages[idx % bgImages.length];

            return (
              <div
                key={idx}
                className="relative overflow-hidden rounded-[24px] p-8 lg:p-10 flex flex-col items-start group hover:border-white/10 transition-all duration-300"
                style={{
                  backgroundImage: `url(${bgImage})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  border: '1px solid rgba(255,255,255,0.05)',
                }}
              >
                {/* Overlay for readability */}
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/30 transition-all"></div>

                {/* Content */}
                <div className="relative z-10 flex flex-col items-start">
                  <div className="w-12 h-12 bg-[#1d63a3]/40 rounded-xl flex items-center justify-center mb-8 border border-[#1d63a3]/20 group-hover:scale-110 transition-transform">
                    <Icon className="w-6 h-6 text-[#3b82f6]" strokeWidth={1.5} />
                  </div>

                  <h3 className="text-white font-bold text-xl mb-4">
                    {pillar?.title?.value || `Pillar ${idx + 1}`}
                  </h3>

                  <div
                    className="text-gray-200 text-sm sm:text-[15px] leading-relaxed font-medium prose prose-invert prose-sm max-w-none [&>p]:mb-3 [&>ul]:list-disc [&>ul]:pl-5"
                    dangerouslySetInnerHTML={{ __html: pillar?.description?.value || '' }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}